import * as React from "react";
const SvgFiRrLeave = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leave_svg__a)">
      <path
        fill="#062147"
        d="M24 15c0 .617-.24 1.198-.678 1.634l-2.072 2.073a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.413L21.128 16H15a1 1 0 1 1 0-2h6.128l-1.292-1.293a.999.999 0 1 1 1.414-1.414l2.073 2.075c.437.435.677 1.015.677 1.633M6.5 11a1.5 1.5 0 1 0 .001 3.002A1.5 1.5 0 0 0 6.5 11m9.5 8v2c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V5.621A5.01 5.01 0 0 1 4.019.718L7.216.08a3.99 3.99 0 0 1 3.321.83c.375.306.665.684.902 1.091H12c2.206 0 4 1.794 4 4v5a1 1 0 1 1-2 0V6c0-1.103-.897-2-2-2v18h1a1 1 0 0 0 1-1v-2a1 1 0 1 1 2 0M10 4.001c0-.602-.267-1.165-.731-1.546a2 2 0 0 0-1.662-.415l-3.196.64A3.01 3.01 0 0 0 2 5.62v15.38c0 .551.449 1 1 1h7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leave_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeave;
